import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const GraphIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="44" height="44" viewBox="0 0 44 44" {...props}>
    <path
      id="Union_15"
      data-name="Union 15"
      d="M0,44V0H4.883V25.792l.057.024c.448-.449.872-.927,1.349-1.343A9.884,9.884,0,0,0,8.7,21.149c1.2-2.532,2.49-5.024,3.75-7.529a2.454,2.454,0,0,1,4-.631c1.2,1.2,2.4,2.4,3.591,3.6a.323.323,0,0,0,.389.1q2.788-.936,5.581-1.855a2.442,2.442,0,0,1,2.974,1.02q1.637,2.45,3.269,4.9c.061.093.124.184.2.292.064-.037.126-.068.183-.105,1.409-.939,2.821-1.875,4.225-2.821a.724.724,0,0,0,.265-.34q1.045-3.1,2.072-6.209a2.477,2.477,0,0,1,2.426-1.794,2.424,2.424,0,0,1,2.3,3.044c-.422,1.438-.927,2.854-1.4,4.277-.355,1.069-.718,2.136-1.072,3.206a2.444,2.444,0,0,1-.988,1.306c-2.433,1.626-4.865,3.257-7.306,4.868a2.424,2.424,0,0,1-3.475-.76Q27.85,23,26.035,20.263c-.048-.071-.1-.141-.153-.22L22.22,21.259c-.617.2-1.232.418-1.852.613a2.4,2.4,0,0,1-2.588-.614c-.754-.744-1.5-1.5-2.247-2.246-.061-.059-.124-.117-.2-.193-.189.376-.369.73-.546,1.084-.907,1.813-1.8,3.63-2.729,5.432a4.154,4.154,0,0,1-.731,1.019Q8.207,29.5,5.058,32.613a.526.526,0,0,0-.173.414c.006,1.927,0,3.852,0,5.779V39.1h39.1V44ZM29.341,7.326V0H41.55V7.326Z"
      fill="#3477eb"
    />
  </Svg>
));

GraphIcon.displayName = 'GraphIcon';

export default GraphIcon;
